import { Injectable } from '@angular/core';
import {palettes} from './colorbrewer';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { parseCSV, TableRow } from '../public-api';

export type ColourSpecification = string;
export type ColourPalette = Array<ColourSpecification>;


const DEFAULT_NUM_COLOURS=3;

@Injectable()
export class PaletteService {
  namedPalettes:{[key:string]:ColourPalette} = {};
  categoricalPalettes:{[key:string]:string} = {};
  loadedCategoricalPalettes:{[key:string]:Observable<TableRow[]>}={};
  constructor(private _http:HttpClient) {

  }

  private _source:string='';
  set source(val:string){
    this._source=val;
  }

  getLocalPalette(name:string,reverse?:boolean,numColours?:number):ColourPalette{
    var palette:(ColourPalette|null)=null;
    if(this.namedPalettes[name]){
      palette = this.namedPalettes[name];
    } else if(palettes[name]){
      palette = palettes[name][numColours||DEFAULT_NUM_COLOURS];
    } else {
      return null;
    }

    if(reverse){
      return palette.slice().reverse();
    }
    return palette.slice();
  }

  updateCategoricalPalette(name:string):void{
    if(this.loadedCategoricalPalettes[name]||!this.categoricalPalettes[name]){
      return;
    }
    const url = this.categoricalPalettes[name];
    this.loadedCategoricalPalettes[name] = this._http.get(url,{ responseType: 'text' }).pipe(
      map((text:string)=>parseCSV(text)),
      shareReplay()
    );
  }

  getPalette(name:string,reverse?:boolean,numColours?:number):Observable<ColourPalette>{
    let palette:(ColourPalette|null)=this.getLocalPalette(name,reverse,numColours);

    if(palette){
      return of(palette);
    }

    this.updateCategoricalPalette(name);
    if(this.loadedCategoricalPalettes[name]){
      return this.loadedCategoricalPalettes[name].pipe(
        map(extractColoursFromPaletteTable));
    }

    return this._http.get(this._source+'/'+name+'.pal',{ responseType: 'text' }).pipe(
      map((text:string)=>this.parseNCWMSPalette(text)));
  }

  getLabels(name:string):Observable<string[]|null>{
    this.updateCategoricalPalette(name);
    if(!this.loadedCategoricalPalettes[name]){
      return of(null);
    }

    return this.loadedCategoricalPalettes[name].pipe(
      map(data=>data.map(row=>row['Class_Name']||row['Label'] || row['label'] || row['NAME'] || row['Name'] || row['name']))
    );
  }

  parseNCWMSPalette(txt:string):ColourPalette{
    return txt.split('\n')
      .map(ln=>ln.replace(/\#.*/g,'').trim().replace(/ +/g,' '))
      .filter(ln => ln.length)
      .map(e=> `rgb(${e.split(' ').join(',')})`);
  }

  colourIndex(val:number,min:number,max:number,count:number):number{
    let point = (val-min)/(max-min);
    let pos = Math.round(point*(count-1));
    return pos;
  }
}

function extractColoursFromPaletteTable(data:TableRow[]):ColourPalette{
  const colours:ColourPalette = data.map(row=>{
    const r = row['Red'] || row['R'] || 0;
    const g = row['Green'] || row['G'] || 0;
    const b = row['Blue'] || row['B'] || 0;
    const a = row['Alpha'] || row['A'] || 255;
    return `rgba(${r},${g},${b},${a/255})`;
  });
  return colours;
}


